/**
 * @fileoverview Current User Context
 *
 * Exposes the authenticated user and their corresponding Airtable Team
 * record (fetched at app startup in App.js via the `getUserRole`
 * callable) to deeply nested admin components without prop drilling.
 *
 * The context value shape:
 *   {
 *     user:     Firebase auth user object | null,
 *     userData: { id, email, name, role, phone } | null,
 *   }
 *
 * `userData.name` mirrors FIELDS.TEAM.NAME from Airtable and is the
 * authoritative display name for RSH team members (use this in place of
 * Firebase Auth `displayName` when attributing uploads, comments, etc.).
 *
 * @version 1.0.0
 */
import { createContext } from "react";

/**
 * React context carrying the current Firebase user and their Airtable
 * Team record. Defaults to `{ user: null, userData: null }` so consumers
 * rendered outside a provider get a predictable shape.
 *
 * @type {React.Context<{ user: Object|null, userData: Object|null }>}
 */
const CurrentUserContext = createContext({ user: null, userData: null });

export default CurrentUserContext;
